import { useToggleState } from '@cian/react-utils';
import { ArticleHeading2, ArticleHeading3, useDeviceType } from '@cian/ui-kit';
import { useState } from 'react';
import { AnswersOnQuestions } from 'shared/components/AnswersOnQuestions';
import { ANSWERS_ON_QUESTIONS } from 'shared/constants/answersOnQuestions';
import { caQuestion, caQuestionGroup } from 'shared/components/tracking';
import { IAnswersOnQuestions } from 'shared/types/answersOnQuestions';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const AnswersOnQuestionsContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const answersQuestions =
    config.get<IAnswersOnQuestions[]>('info-subsidized-mortgage-frontend.answersQuestions') || [];

  const [activeBlock, setActiveBlock] = useState(ANSWERS_ON_QUESTIONS[0]);

  const { state: modalVisible, toggle: toggleModalVisible } = useToggleState(false);

  const device = useDeviceType();

  const BlockTitle = device === 'phone' ? ArticleHeading3 : ArticleHeading2;

  const handleActiveBlock = (newBlock: IAnswersOnQuestions) => {
    caQuestionGroup(newBlock.title, device);
    toggleModalVisible();
    setActiveBlock(newBlock);
  };

  const handleQuestionClick = (question: string, isOpen: boolean) => {
    if (isOpen) {
      caQuestion(activeBlock.title, question, device);
    }
  };

  if (answersQuestions.length === 0) {
    return null;
  }

  return (
    <AnswersOnQuestions
      answersOnQuestions={answersQuestions}
      BlockTitle={BlockTitle}
      device={device}
      activeBlock={activeBlock}
      modalVisible={modalVisible}
      onCloseModal={toggleModalVisible}
      onActiveBlock={handleActiveBlock}
      onQuestionClick={handleQuestionClick}
    />
  );
};
